module.exports = __webpack_public_path__ + "static/media/GTXSortingLogo.28ac862f.svg";